module.exports = __webpack_public_path__ + "static/img/partner6.e68ffef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/partner6.png
// module id = same
// module chunks = 0